import { render, staticRenderFns } from "./PorAnoMensagemVeto.vue?vue&type=template&id=4c0a1731&scoped=true"
import script from "./PorAnoMensagemVeto.vue?vue&type=script&lang=js"
export * from "./PorAnoMensagemVeto.vue?vue&type=script&lang=js"
import style0 from "./PorAnoMensagemVeto.vue?vue&type=style&index=0&id=4c0a1731&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a1731",
  null
  
)

export default component.exports